import * as React from 'react';
import { ChevronRight } from '@kvika/icons';
import Step, { StepState } from './Step';
import { StyledChevronContainer, StyledProgressStepper, StyledProgressStepperContainer, StyledStepItemContainer, } from './styles/ProgressStepperStyles';
var ProgressStepper = function (_a) {
    var className = _a.className, steps = _a.steps, currentStepIndex = _a.currentStepIndex, _b = _a.testId, testId = _b === void 0 ? 'kvika-progress-stepper' : _b;
    var getStepType = function (stepId) {
        if (currentStepIndex > stepId) {
            return StepState.COMPLETE;
        }
        if (currentStepIndex === stepId) {
            return StepState.CURRENT;
        }
        return StepState.NEXT;
    };
    return (React.createElement(StyledProgressStepperContainer, { className: className, "data-testid": testId },
        React.createElement(StyledProgressStepper, null, steps.map(function (step, index) {
            var stepNumber = index + 1;
            var key = "step-".concat(index);
            return (React.createElement(StyledStepItemContainer, { key: key, isLastItem: index === steps.length - 1 || false },
                React.createElement(Step, { number: stepNumber, index: index, label: step.label, stepType: getStepType(index) }),
                index < steps.length - 1 && (React.createElement(StyledChevronContainer, null,
                    React.createElement(ChevronRight, null)))));
        }))));
};
export default ProgressStepper;
//# sourceMappingURL=ProgressStepper.js.map